import { lazy } from 'react';


export const GeeksJunior = lazy(() => import('./GeeksJunior'));
